import React from "react";
import { ChevronRight, CircleHelp, MessageCircleQuestion } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useSugestoes } from "../hooks/Sugestoes";
import i18n from "../i18n";

interface CategoriaProps {
  appSlug: string;
  // Antes a sugestão só preenchia o campo; agora ela é enviada direto.
  aoEscolher: (pergunta: string) => void;
  desabilitado?: boolean;
  // "lista": "Talvez sua dúvida esteja aqui", uma pergunta por linha (tela inicial).
  // "pilulas": perguntas lado a lado, embaixo do campo da conversa.
  formato?: "lista" | "pilulas";
}

const decodeHtmlEntities = (str: string) => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(str, "text/html");
  return doc.documentElement.textContent || "";
};

// Sugestões dinâmicas: a cada visita, 3 das perguntas mais buscadas do app (ver useSugestoes).
const ExibirPerguntasFrequentesPorSlug: React.FC<CategoriaProps> = ({
  appSlug,
  aoEscolher,
  desabilitado = false,
  formato = "pilulas",
}) => {
  const { t } = useTranslation();
  const { exibidas } = useSugestoes(appSlug, i18n.language === "es" ? "es" : "pt");

  if (exibidas.length === 0) return null;

  if (formato === "lista") {
    return (
      <div className="perguntas-lista">
        <p className="perguntas-lista-titulo">
          <CircleHelp size={13} strokeWidth={1.5} aria-hidden="true" />
          <span>{t("talvez_sua_duvida")}</span>
        </p>
        {exibidas.map((pergunta) => (
          <button
            key={pergunta}
            className="pergunta-item"
            disabled={desabilitado}
            onClick={() => aoEscolher(decodeHtmlEntities(pergunta))}
          >
            {/* Ícone só aparece no computador, onde as perguntas viram cartões. */}
            <MessageCircleQuestion className="pergunta-item-icone" size={16} strokeWidth={1.5} aria-hidden="true" />
            <span>{decodeHtmlEntities(pergunta)}</span>
            <ChevronRight className="pergunta-item-seta" size={15} strokeWidth={1.5} aria-hidden="true" />
          </button>
        ))}
      </div>
    );
  }

  return (
    <div className="flex justify-center box-categorias">
      {exibidas.map((categoria) => (
        <button
          key={categoria}
          disabled={desabilitado}
          onClick={() => aoEscolher(decodeHtmlEntities(categoria))}
        >
          <span className="badge rounded-pill bg-secondary">
            {decodeHtmlEntities(categoria)}
          </span>
        </button>
      ))}
    </div>
  );
};

export default ExibirPerguntasFrequentesPorSlug;
